import '../App.css';

import React, { ReactNode } from 'react';
import { Toaster } from 'react-hot-toast';

import { Header } from '../components/Header';
import Sidebar from '../components/Sidebar/index';
import { useStateContext } from '../hooks/context/Context';
import FooterImg from '../images/layout/Ellipse.png';

const DefaultLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const { activeMenu, setActiveMenu } = useStateContext();

  const handleSidebarToggle = () => {
    setActiveMenu(!activeMenu);
  };

  return (
    <div className="flex h-screen overflow-hidden ">
      <div className={`flex relative dark:bg-main-dark-bg`}>
        <div
          className={`dark:bg-secondary-dark-bg bg-main-bg transition-all duration-300 ${
            activeMenu ? "block w-65" : "w-18"
          }`}
        >
          <Sidebar />
        </div>
      </div>
      <div
        className={
          activeMenu
            ? `dark:bg-main-dark-bg bg-main-bg min-h-full w-full transition-all duration-300`
            : "bg-main-bg dark:bg-main-dark-bg w-full min-h-full flex-2 transition-all duration-300"
        }
      >
        <div className="relative flex flex-1 flex-col bg-mainBg overflow-y-auto overflow-x-auto ">
          <div className={`fixed md:static navbar w-full`}>
            <Header isLoggedIn={true} onSidebarToggle={handleSidebarToggle} />
          </div>
          <main className="relative  h-full overflow-auto mt-2">
            <div className="mx-auto 2xl:max-w-screen-2xl xl:max-w-screen-xl max-w-screen-lg -ml-2 relative z-10">
              {children}
            </div>
            <div className="absolute bottom-0 right-0 ">
              <img
                src={FooterImg}
                className="w-full h-60 object-cover"
                alt="footImg"
              />
            </div>
          </main>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default DefaultLayout;
